import { render, staticRenderFns } from "./ChooseWine.vue?vue&type=template&id=09b0dc56"
import script from "./ChooseWine.vue?vue&type=script&lang=js"
export * from "./ChooseWine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports